import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import {
  ReplaySubject,
  combineLatest,
  filter,
  map,
  pipe,
  switchMap,
} from 'rxjs';

import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ZalamoObject } from 'Upload/upload/graphql';

import { GetQuickLinkGQL } from 'ZalamoLibrary/src/lib/ui/quick-link/graphql';

import { OrdersService } from '../orders/services/orders.service';
import { OrganizationService } from '../../core/organizations/organization.service';
import { Store } from '@ngrx/store';
import { selectCurrentLanguage } from 'ZalamoLibrary/src/lib/zalamo/language/redux/language.selectors';

@Component({
  selector: 'lib-quick-link',
  templateUrl: './quick-link.component.html',
  styleUrls: ['./quick-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QuickLinkComponent implements OnInit, OnChanges {
  @Input() context: ZalamoObject;
  @Input() contextId: string;
  @Input() @HostBinding('class.clickable') clickable = true;
  current$ = new ReplaySubject<{ context: ZalamoObject; contextId: string }>(1);

  link$ = this.current$.pipe(
    switchMap(({ context, contextId }) => {
      if (context === ZalamoObject.Order) {
        return combineLatest([
          this.organizationService.getCurrentOrganization(),
          this.store.select(selectCurrentLanguage),
        ]).pipe(
          switchMap(([organizationId, language]) =>
            this.ordersService
              .getOrderFromCache(contextId, organizationId)
              .pipe(
                map((v) => ({
                  label: [{ language, text: v.orderNumber }],
                  link: `/orders/${v.orderNumber}`,
                })),
              ),
          ),
        );
      }
      return this.getQuickLinkGQL
        .watch(
          { variables: { context, contextId } },
          // {
          //   fetchPolicy: 'network-only',
          // }
        )
        .valueChanges.pipe(
          throwOnQueryError,
          filter(hasCompleteQueryData),
          map((result) => result.data['quickLink']),
        );
    }),
  );

  constructor(
    private getQuickLinkGQL: GetQuickLinkGQL,
    private ordersService: OrdersService,
    private organizationService: OrganizationService,
    private store: Store,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.context && changes.contextId) {
      this.current$.next({
        context: changes.context?.currentValue,
        contextId: changes.contextId?.currentValue,
      });
    } else if (changes.contextId) {
      this.current$.next({
        context: this.context,
        contextId: changes.contextId?.currentValue,
      });
    }
  }

  ngOnInit(): void {}
}
